import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import AddBalanceForm from './components/AddBalanceForm'
import PaymentSources from './components/PaymentSources'
import MasterNewChargeForm from './components/MasterNewChargeForm'
import AvailableFundsHistory from './components/AvailableFundsHistory'
import { Card } from '../../onestep-library/BaseUI'
import { moneyize } from '../../onestep-library/TextPresenters/moneyize'
import { fetchAccountBalance } from './actions'
import { Elements } from 'react-stripe-elements'
import classnames from 'classnames'

function AccountBalance(props){
  const dispatch = useDispatch();
  const { balance, billed, received, outstanding, refunded } = useSelector(state => state.account);
  const { pendingInvoices } = useSelector(state => state.pendingInvoices);
  const { organization, resident } = useSelector(state => state);

  function getAmountDue(){
    var total = 0
    pendingInvoices.map(invoice => {
      return total = total + Number(invoice.balance)
    })
    return total
  }

  const headerButtons = [
    {
      label: 'Payment Info', 
      handleClick: ()=>dispatch({type: 'UPDATE_PAYMENT_SOURCES_UI', payload: { show: true } })
    },
    {
      label: 'Add Funds', 
      handleClick: ()=>dispatch({type: 'UPDATE_ADD_BALANCE_UI', payload: { show: true } })
    },
    {
      label: 'New', 
      handleClick: ()=>dispatch({type: 'UPDATE_MASTER_CHARGE_FORM_UI', payload: { show: true } })
    },
  ]

  useEffect(()=>{
    dispatch(fetchAccountBalance())
  },[pendingInvoices])

  return(
    <div>
      <Elements>
        <AddBalanceForm/>
      </Elements>
      <PaymentSources/>
      <Elements>
        <MasterNewChargeForm/>
      </Elements>
      <AvailableFundsHistory/>
      <Card
        title="Account"
        headerButtons={headerButtons}>
        <div className="card-body d-sm-block d-md-flex justify-content-around pt-5 pb-5 w-100">
          <div className="d-flex flex-column align-items-center">
            <h1>{moneyize(balance)}</h1>
            <div className="text-secondary">Available Funds</div>
            <div className="text-primary cursor-pointer" onClick={()=>dispatch({type:'UPDATE_AVAILABLE_FUNDS_HISTORY_UI', payload: {show: true}})}>View History</div>
          </div>
          <div className="d-flex align-items-center">
            <div className=''>
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-secondary">Billed</div>
                <div style={{fontSize: '1.3em', fontWeight: '500'}} className="ml-3">{moneyize(billed)}</div>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-1">
                <div className="text-secondary">
                  Paid + Available Funds
                </div>
                <div style={{fontSize: '1.3em', fontWeight: '500'}} className="ml-3">{moneyize(received)}</div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-secondary">Refunded</div>
                <div style={{fontSize: '1.3em', fontWeight: '500'}} className="ml-3">{moneyize(refunded)}</div>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-1">
                <div className="text-secondary">Outstanding</div>
                <div style={{fontSize: '1.3em', fontWeight: '500'}} className={classnames("ml-3", {"text-danger": outstanding < 0, "text-success": outstanding >= 0})}>{moneyize(outstanding)}</div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default AccountBalance